import { createInertiaApp } from '@inertiajs/svelte'
import axios from 'axios'
import { mount } from 'svelte'

const pages = import.meta.glob('../pages/**/*.svelte')

const csrfTokenElement = document.querySelector('meta[name=csrf-token]')
if (csrfTokenElement) {
  axios.defaults.headers.common['X-CSRF-Token'] = csrfTokenElement.content
}

// Use port-specific XSRF cookie name to avoid collisions between worktrees
const port = window.location.port || '80'
axios.defaults.xsrfCookieName = `XSRF-TOKEN-${port}`

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/service-worker.js').catch(() => {})
}

window.addEventListener('unhandledrejection', (event) => {
  if (
    /dynamically imported module|Importing a module script/.test(
      event.reason?.message,
    )
  ) {
    window.location.reload()
  }
})

createInertiaApp({
  resolve: (name) => {
    const importPage = pages[`../pages/${name}.svelte`]
    if (!importPage) throw new Error(`Page not found: ${name}`)
    return importPage().catch(() => window.location.reload())
  },
  setup({ el, App, props }) {
    mount(App, { target: el, props })
  },
})
